import { Component } from '@angular/core';
import { LnImageFrameComponent } from '@components/ln-image-frame/ln-image-frame.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'ln-contact-page-header',
  imports: [LnImageFrameComponent, TranslocoPipe],
  templateUrl: './contact-page-header.component.html',
  styleUrl: './contact-page-header.component.css',
})
export class ContactPageHeaderComponent {
  protected imageUrl = environment.GOOGLE_STORAGE_URL + '/imagenes/' + environment.banners.CONTACT;
}
